export default "__VITE_ASSET__Bd$qz0_1__"